import { logger } from '../../../util/logger';
import { renderModel } from '../../../util/renderModel';
import { httpClient } from '../../httpClient';
import { getMediaType } from './getMediaType';
import { UploadUrlResponse } from './types';

export const getUploadUrl = async (file: File, mediaAuthToken: string | null): Promise<UploadUrlResponse> => {
  try {
    const mediaType = getMediaType(file);

    const { data } = await httpClient
      .getInstance()
      .get<UploadUrlResponse>(`https://files.wix.com/site/media/files/upload/url?media_type=${mediaType}`, {
        headers: {
          authorization: `APP ${mediaAuthToken}`,
        },
      });

    return data;
  } catch (error) {
    logger.log({
      message: 'fail to get upload url and token',
      error,
      callParams: renderModel.get(),
    });
    throw error;
  }
};
